import axios from 'axios';
import axiosRetry from 'axios-retry';

axiosRetry(axios, {
    retries: 3, // Number of retry attempts
    retryDelay: (retryCount) => {
        return retryCount * 2000; // Delay between retries (2 seconds per attempt)
    },
    retryCondition: (error) => {
        // Retry only for network errors or 5xx server errors
        return (error.response?.status ?? 0) >= 500 || error.code === 'ECONNABORTED';
    },
});

export const registerConsumption = async (audioFileDuration: number, playedSeconds: number[], audioName: string, clientName: string, publisherName: string,
    topicName: string, autoPlay: boolean, playlistName: string | null = null): Promise<boolean> => {

    const backendRoute: string = process.env.REACT_APP_BACKEND_ROUTE || '';
    const backendAuth: string = process.env.REACT_APP_BACKEND_AUTH || '';
    const consumptionUrl = `${backendRoute}/consumption/registerConsumption`;
    const countOfPlayedSeconds = playedSeconds.length - 1;

    if (countOfPlayedSeconds > 0) {
        const postData = {
            audioName,
            clientName,
            audioDuration: audioFileDuration,
            playedDuration: countOfPlayedSeconds,
            publisherName,
            topicName,
            autoPlay,
            playlistName,
        }

        /**
         * The sendBeacon method is a way to send data to a web server asynchronously without blocking the page load.
         * It is particularly useful for sending analytics data or other information when a user is navigating away from a page.
         * 
         * beforeunload event handler might not have enough time to complete its execution before the browser unloads the page. 
         * Modern browsers often impose strict time limits on what can be done during the beforeunload event, 
         * and asynchronous operations (like API calls) may not complete in time.
         */
        // Use navigator.sendBeacon if available
        if (navigator.sendBeacon) {
            const blob = new Blob([JSON.stringify(postData)], { type: 'application/json' });
            const success = navigator.sendBeacon(consumptionUrl, blob);

            return success; // Returns true if the beacon was queued successfully
        } else {
            // Fallback to axios for browsers that don't support sendBeacon
            try {
                const resp = await axios.post(consumptionUrl, postData, {
                    withCredentials: true,
                    headers: {
                        "apikey": backendAuth,
                        'Content-Type': 'application/json'
                    }
                });

                return resp.status === 200;
            } catch (error) {
                console.error('Error registering consumption:', error);
                return false;
            }
        }
    }
    return true;
}
